import { createApi } from '@reduxjs/toolkit/query/react'
import { NetWork } from '../../../common/apiKey'
import { DELETE, GET, POST, PUT } from '../../../common/contants'
import { axiosBaseQuery } from '../../baseQuery'

export const notificationApi = createApi({
  reducerPath: 'notificationApi',
  baseQuery: axiosBaseQuery,
  tagTypes: ['Notification'],
  endpoints: (builder) => ({
    getNotifications: builder.query({
      query: (params) => ({
        url: NetWork.notification,
        method: GET,
        params: params
      }),
      providesTags: (result) => (result ? [{ type: 'Notification', id: 'LIST' }] : [])
    }),
    markAsRead: builder.mutation({
      query: (id: number) => ({
        url: NetWork.notificationId(id),
        method: PUT
      }),
      invalidatesTags: [{ type: 'Notification', id: 'LIST' }]
    }),
    markAllRead: builder.mutation({
      query: () => ({
        url: NetWork.notificationMarkAllRead,
        method: PUT
      }),
      invalidatesTags: [{ type: 'Notification', id: 'LIST' }]
    }),
    deleteNotifications: builder.mutation({
      query: (data: { ids: number[] }) => ({
        url: NetWork.notification,
        method: DELETE,
        data: data
      }),
      invalidatesTags: [{ type: 'Notification', id: 'LIST' }]
    }),
    confirmReconciliation: builder.mutation({
      query: (data: { orderId: number; type: 'HU' | 'NGHI_CHI' }) => ({
        url: NetWork.confirmReconciliation,
        method: POST,
        data: data
      })
    })
  })
})

export const {
  useGetNotificationsQuery,
  useMarkAsReadMutation,
  useMarkAllReadMutation,
  useDeleteNotificationsMutation,
  useConfirmReconciliationMutation
} = notificationApi
